import React from 'react'
import CreateAccount from '../components/auth/CreateAccount'

const SignUpPage = () => {
  return (
    <CreateAccount/>
  )
}

export default SignUpPage